export const clientesNuevos = (creditos) =>
  creditos.filter((credito) => credito?.cuentaUsuario?.antiguo === null || credito?.cuentaUsuario?.antiguo === false);
